/**
 * Transfers Filters Component
 *
 * Filter controls for transfers list.
 * @see Sprint 14 - Transferts Inter-Sites
 * @see US-14.5 - UI Liste et Creation
 */

import { Input, Select, Tabs } from '@/components/ui';
import type { Tab } from '@/components/ui';
import { Search } from 'lucide-react';
import { TRANSFER_STATUS_OPTIONS } from '@bstock/shared';

interface TransfersFiltersProps {
  role: 'my_requests' | 'to_process';
  status: string;
  search: string;
  onRoleChange: (role: 'my_requests' | 'to_process') => void;
  onStatusChange: (status: string) => void;
  onSearchChange: (search: string) => void;
  /** Hide role tabs (CENTRAL only sees 'to_process') */
  hideRoleTabs?: boolean;
}

const tabs: Tab[] = [
  { id: 'my_requests', label: 'Mes commandes (IN)' },
  { id: 'to_process', label: 'A envoyer (OUT)' },
];

const statusOptions = [
  { value: '', label: 'Tous les statuts' },
  ...TRANSFER_STATUS_OPTIONS,
];

export function TransfersFilters({
  role,
  status,
  search,
  onRoleChange,
  onStatusChange,
  onSearchChange,
  hideRoleTabs = false,
}: TransfersFiltersProps) {
  return (
    <div className="flex flex-col gap-4">
      {/* Tabs for role filter (hidden for CENTRAL) */}
      {!hideRoleTabs && (
        <Tabs
          tabs={tabs}
          activeTab={role}
          onTabChange={(id) => onRoleChange(id as 'my_requests' | 'to_process')}
        />
      )}

      {/* Additional filters */}
      <div className="flex flex-wrap items-center gap-4">
        {/* Search */}
        <div className="w-64 relative">
          <Search className="w-4 h-4 text-neutral-400 absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" />
          <Input
            placeholder="Rechercher par numero..."
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-10"
          />
        </div>

        {/* Status filter */}
        <div className="w-48">
          <Select
            value={status}
            onChange={onStatusChange}
            options={statusOptions}
            placeholder="Tous les statuts"
            allowEmpty={false}
          />
        </div>
      </div>
    </div>
  );
}
